import { render } from "./TransportsPage.vue?vue&type=template&id=5131207a&ts=true"
import script from "./TransportsPage.vue?vue&type=script&lang=ts"
export * from "./TransportsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__